import Hero from 'components/hero';
import React from 'react';
import { ReactComponent as IconTick } from 'svg/icons/tick.svg';
import './style.css';

const WorkerControl = () => {
  return (
    <Hero layout="grid" className="worker-control">
      <div className="questions">
        <ul>
          <li>
            <IconTick className="tick" />
            <p>Do you want more control over when and where you work?</p>
          </li>
          <li>
            <IconTick className="tick" />
            <p>Do you want more control over your rate of pay?</p>
          </li>
          <li>
            <IconTick className="tick" />
            <p>
              Do you want the freedom to pick up extra shifts on your days off?
            </p>
          </li>
          <li>
            <IconTick className="tick" />
            <p>
              Are you fed-up with waiting for call backs to see if you have been
              successfully placed for a shift?
            </p>
          </li>
        </ul>
      </div>
      <div>
        <p>
          Even if you can only answer yes to one of these questions. MyShifts is
          the solution that you may want to consider.
        </p>
        <p>
          Designed and created by Health and Social Care professionals for our
          sector to provide a better way of working for both workers and
          providers.
        </p>
      </div>
    </Hero>
  );
};

export default WorkerControl;
